"use strict";

const TouchscreenFunctions = () => {
    const init = () => {
        $(function() {
            
        });

        if($('.js-inactivity-timer').length){
            var inactivityTime = function () {
                var t;
                window.onload = resetTimer;
                // DOM Events
                document.onload = resetTimer;
                document.onmousemove = resetTimer;
                document.onmousedown = resetTimer;
                document.ontouchstart = resetTimer;
                document.onclick = resetTimer;
                document.onkeypress = resetTimer;
            
                function logout() {
                    gtag('event', 'CLOSED', {
                        'event_category': 'MEDIA', 
                        'event_label': 'Inactivity Exit - '
                    });
                    location.href="/nsw/touchscreen";
                }
            
                function resetTimer() {
                    clearTimeout(t);
                    t = setTimeout(logout, 600000)
                    // 1000 milisec = 1 sec
                }
            };
            inactivityTime();
        }
    };

    return {
        init:init
    };
};

export default TouchscreenFunctions;